import React from 'react';
import cx from 'classnames';
import { Link, scroller } from 'react-scroll';

import useStyles from './styles';
import { Typography } from '@material-ui/core';
import CheckIcon from '../../../../assets/icons/CheckIcon';
import { colorsPalette } from '../../../../theme';

interface ProgressItemProps {
  id?: string | null;
  title?: string | null;
  active?: boolean;
  nextActive?: boolean;
}

const ProgressItem: React.FC<ProgressItemProps> = ({ id, title, active, nextActive }) => {
  const classes = useStyles();

  const handleScroll = () =>
    scroller.scrollTo(id, {
      duration: 1000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -80,
    });

  return (
    <li className={cx(classes.root, active && 'active', nextActive && 'nextActive')}>
      <div className={classes.circle}>
        {active && <CheckIcon className={classes.circleIcon} color={colorsPalette.blueDark} />}
      </div>
      <Link onClick={handleScroll}>
        <Typography className={classes.title}>{title}</Typography>
      </Link>
    </li>
  );
};

export default ProgressItem;
